import { gql } from '@provision/graphql-client';

export const NOTIFICATION_PREFERENCE_FRAGMENT = gql`
  fragment NotificationPreferenceFields on NotificationPreference {
    id
    notificationPreferenceId
    partnerId
    userId
    notificationChannelId
    notificationEventId
    isActive
  }
`;

export const NOTIFICATION_ROLE_FRAGMENT = gql`
  fragment NotificationRoleFields on NotificationRole {
    id
    notificationRoleId
    name
    category
  }
`;

export const NOTIFICATION_PREFERENCE_RELATIONS_FRAGMENT = gql`
  fragment NotificationPreferenceRelations on NotificationPreference {
    id
    userNotificationRole {
      id
      userNotificationRoleId
      userId
      partnerId
      notificationRoleId
      notificationRole {
        ...NotificationRoleFields
      }
      isActive
      notificationPreferenceId
    }
    notificationEvent {
      id
      notificationEventId
      roles {
        ...NotificationRoleFields
      }
    }
  }
  ${NOTIFICATION_ROLE_FRAGMENT}
`;
